module.exports = __webpack_public_path__ + "static/media/Brain.d780668e.jpg";